import { Component } from '@angular/core';
import { Category } from '../../../models/category/category.model';
import { CategoryService } from '../../../services/category/category.service';
import { convertToParamMap } from '@angular/router';

@Component({
    selector: 'app-create-subcategory',
    templateUrl: './create-subcategory.component.html',
    styleUrls: ['./create-subcategory.component.css']
})
/** create-subcategory component*/
export class CreateSubcategoryComponent {
    /** create-subcategory ctor */
  subCategory = new Category();
  fileToUpload: File;
  fd = new FormData();
  public parentCategoryList: Category[];
  public categoryList: Category[];
  public SubcategoryList: Category[];

  /** create-parent-category ctor */
  constructor(private readonly categoryService: CategoryService) {
    this.subCategory.isActive = true;
    this.subCategory.parentCategoryID = 0;
    this.GetCategoryList();


  }
  uploadTinyImage(file: FileList) {
    this.fileToUpload = file.item(0);
    this.fd.append("TinyImage", this.fileToUpload);
  }
  uploadSmallImage(file: FileList) {
    this.fileToUpload = file.item(0);
    this.fd.append("SmallImage", this.fileToUpload);
  }
  uploadLargeImage(file: FileList) {
    this.fileToUpload = file.item(0);
    this.fd.append("LargeImage", this.fileToUpload);
  }

  GetCategoryList() {
    this.categoryService.GetCategoryList().subscribe(
      data => {
        this.parentCategoryList = data
      }
    )
  }

  GetCategoryListByParent(parentCategoryId: number) {
    this.categoryService.GetCategoryListByParent(parentCategoryId).subscribe(
      data => {
        this.categoryList = data
      }
    )
  }
 

  onTextChange(Value: string) {
    var i = 0, strLength = Value.length;
    for (i; i < strLength; i++) {
      Value = Value.replace(" ", "");
    }
    this.subCategory.url = Value.toLowerCase();
  }

  onSubmit() {
    this.fd.append("CategoryName", this.subCategory.categoryName);
    this.fd.append("IsActive", this.subCategory.isActive.toString());
    this.fd.append("Url", this.subCategory.url);
    this.fd.append("Detail", this.subCategory.detail);
    this.fd.append("ParentCategoryID", this.subCategory.parentCategoryID.toString());
    this.fd.append("IsParent", "false");
    this.categoryService.AddSubCategory(this.fd);
  }
}



// WEBPACK FOOTER //
// ./src/app/category-components/subcategory/create-subcategory/create-subcategory.component.ts